module.exports = " <div id=nublox-panel> <grid-row v-for=\"row in json._children\" :row=row :index=$index :parent=json :displaysize=displaysize></grid-row> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel.vue
 ** module id = 74
 ** module chunks = 0
 **/